import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { INSGridConfig } from '@norfolk-southern/accessns-components';
import { ColDef } from 'ag-grid-community';

import { NSEBillConstants } from '@ruby/configs/ebill.constants';
import { EBillWaybillIndEnum } from '@ruby/shared/enums/ebill.enums';
import { IEBillFinanceDetails, IEBillInvoiceSummary } from '@ruby/shared/models/ebill/ebil.interface';

@Component({
  selector: 'ng-ebill-finance',
  templateUrl: './ebill-finance.component.html',
  styleUrls: ['./ebill-finance.component.scss']
})
export class EBillFinanceComponent implements OnChanges {
  @Input() data?: IEBillFinanceDetails;
  @Input() loading!: boolean;
  @Input() isDownloading!: boolean;
  @Input() bill!: Partial<IEBillInvoiceSummary>;
  @Output() downloadExcel = new EventEmitter();
  @Output() refreshGrid = new EventEmitter();
  title = '';
  columns: Array<ColDef> = [];
  config: INSGridConfig = {
    hide: { download: { xlsAll: true } }
  };

  constructor(private location: Location) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.bill && changes.bill.currentValue) {
      this.setTitle(changes.bill.currentValue.wayBillIndicatorType, changes.bill.currentValue.freightBillNumber);
    }
  }

  /**
   * Navigate Back
   *
   * @summary return to bill details
   * @return void
   */
  navigateBack(): void {
    this.location.back();
  }

  private setTitle(waybillInd: string, invoice: string): void {
    switch (waybillInd) {
      case EBillWaybillIndEnum.C:
        this.title = `Finance Charge for Invoice - ${ invoice }`;
        this.columns = NSEBillConstants.financeDetailGridColumns;
        break;
      case EBillWaybillIndEnum.F:
        this.title = `Fuel Surcharge for Invoice - ${ invoice }`;
        this.columns = NSEBillConstants.fuelChargeDetailsGridColumns.filter(
          (col: ColDef) => col.field !== 'surchargeFactor' && col.field !== 'surchargeMilesSource' && col.field !== 'surchargeMiles');
        break;
      case EBillWaybillIndEnum.M:
        this.title = `Mileage Fuel Surcharge for Invoice - ${ invoice }`;
        this.columns = NSEBillConstants.fuelChargeDetailsGridColumns;
        break;
    }
  }
}
